import { useState, useCallback, useRef, useEffect } from 'react';

/**
 * Tiny hook for copy-button "checkmark for 2 seconds" pattern.
 * Cleans up the timeout on unmount so the setState call doesn't fire on
 * an unmounted component (which is harmless in React 18 but still leaky).
 */
export default function useCopyState(resetMs = 2000): [boolean, () => void] {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const trigger = useCallback(() => {
    setCopied(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setCopied(false);
      timerRef.current = null;
    }, resetMs);
  }, [resetMs]);

  // Clear pending timer on unmount
  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );

  return [copied, trigger];
}
